import { AppErrorCode } from '../enums/app-error-code.enum';

const APP_ERROR_CODES = new Set<string>(Object.values(AppErrorCode));

export function isAppErrorCode(
  value: string | null | undefined
): value is AppErrorCode {
  return value !== null && value !== undefined && APP_ERROR_CODES.has(value);
}
